import {
  Component, Inject, OnInit, OnDestroy,
} from '@angular/core';
import {
  MAT_DIALOG_DATA, MatDialog, MatDialogRef,
} from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-push-modal',
  templateUrl: './push-modal.component.html',
  styleUrls: [ './push-modal.component.scss' ],
})
export class PushModalComponent implements OnInit, OnDestroy {
  selectedPrimaryPushType: any = null;
  completeCourseSessionDetails: any;
  user: any;
  userSubscription: any;
  permissions: any;
  permissionsSubscrioption: any;

  constructor(
    public dialogRef: MatDialogRef<PushModalComponent>,
    public dialog: MatDialog,
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.completeCourseSessionDetails = this.data?.completeCourseSessionDetails;
    this.userSubscription = this.authService.user$.subscribe((user: any) => {
      this.user = user;
    });
    this.permissionsSubscrioption = this.authService.permissions$.subscribe((permissions: any) => {
      this.permissions = permissions;
    });
  }

  /**
   * "Duplicate & Push" is gated on:
   *  - the COURSE_BATCH_DUPLICATE feature flag being enabled in the env
   *  - admin-level permissions: COURSE_ADD AND COURSE_PUSH
   * Mirrors the backend's `requireFeatureFlag` + `allRequired: true` check so
   * the option only appears when the API will actually accept the request.
   */
  showDuplicateAndPush = (): boolean => {
    const featureEnabled = !!environment?.features?.courseBatchDuplicate;
    if (!featureEnabled) return false;
    const canAdd = this.permissions?.COURSE_ADD === 1 || this.permissions?.COURSE_ADD === true;
    const canPush = this.permissions?.COURSE_PUSH === 1 || this.permissions?.COURSE_PUSH === true;
    return canAdd && canPush;
  }

  /**
   * Forwards refresh requests from the duplicate flow up to whoever opened
   * this modal so the underlying course list reflects the new entries.
   */
  onDuplicateAndPushClosed = (refresh: 'reload' | undefined) => {
    if (refresh === 'reload') {
      this.dialogRef.close('reload');
    }
  }

  closeModal = () => {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.permissionsSubscrioption.unsubscribe();
  }

}
